<template>
	<div class="crm__body">
		<div class="crm__head">
			<label>
				<select class="uk-select" name="filial" v-model="filial">
					<option value="3">Кул Гали, 24</option>
					<option value="2">Ленская 10</option>
				</select>
			</label>
			<button @click="getCustomers(page)" class="uk-button uk-button-primary">Получить</button>
		</div>

		<div class="crm__clients" v-if="customers.length > 0">
			<h4>Список клиентов</h4>
			<ul>
				<li class="crm__client" v-for="client in customers">
				<small>id:</small> {{ client.id }} - <small>Тел.</small> {{ client.phone[0] }} - <small>Контакт:</small> {{ client.legal_name }} - <small>Имя:</small> {{ client.name }}
				</li>
			</ul>
		</div>

		<div class="crm__pages" v-if="total_pages">
			<ul>
				<li v-for="item in (total_pages + 1)" :class="(item == (+page)) ? 'active' : ''">
					<a href="#" @click.prevent="getCustomers(item)">{{ item }}</a>
				</li>
			</ul>
		</div>

	</div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: "crm",
    data() {
      return {
        filial: 3,
        customers: [],
	      total_pages: '',
        page: 1
      }
    },
    props: {
      items: ''
    },
    methods: {
      getCustomers(page) {
        this.page = page;
        let data = {
          page: page - 1 ,
          filial: this.filial
        }
        let app = this;
        console.log(data);
        axios.post(window.location.href, data, {
          headers: {
            'X-OCTOBER-REQUEST-HANDLER': 'onGetCustomers',
          }
        }).then(function (res) {
          console.log(res);
          app.customers = res.data.items;
          app.total_pages = Math.round((res.data.total / 20));
        });
      }
    }
  }
</script>